import {
    ADDNEWWITHDRAWLIMIT_SUCCESS,
    ADDNEWWITHDRAWLIMIT_FAILED,
    RESET_ADDNEWWITHDRAWLIMIT,
    LOADING_ADDNEWWITHDRAWLIMIT,
    NETWORK_ERROR_ADDNEWWITHDRAWLIMIT,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADDNEWWITHDRAWLIMIT:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case ADDNEWWITHDRAWLIMIT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case ADDNEWWITHDRAWLIMIT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_ADDNEWWITHDRAWLIMIT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_ADDNEWWITHDRAWLIMIT:
            return (state = initialState);
        default:
            return state;
    }
};
